/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ICheckoutApplePayViewProps } from './custom-checkout-apple-pay';

const CheckoutApplePayView: React.FC<ICheckoutApplePayViewProps> = props => {
    const { checkoutApplePay, applePayButton, alert } = props;

    return (
        <Module {...checkoutApplePay}>
            {alert}
            {applePayButton}
        </Module>
    );
};

export default CheckoutApplePayView;
